<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div v-show="pagetype === 1">
      <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('商家')" prop="merchantId">
                  <a-select  show-search :filter-option="merchantFilter"  v-model="queryParam.merchantId" :maxLength="32" :placeholder="$t('请选择')+$t('商家')" allow-clear>
                    <a-select-option v-for="item in merchantList" :key="item.id">{{ item.merchantName }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('商品编号')" prop="id">
                  <a-input v-model="queryParam.id" @pressEnter="handleQuery" :maxLength="20" :placeholder="$t('请输入')+$t('商品编号')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('商品名称')" prop="goodsName">
                  <a-input v-model="queryParam.goodsName" @pressEnter="handleQuery"  :placeholder="$t('请输入')+$t('商品名称')" allow-clear/>
                </a-form-item>
              </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item :label="$t('商品分类')" prop="merchantCategoryId">
                    <a-tree-select v-model="queryParam.merchantCategoryId" style="width: 100%"
                                   :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="cateOptions" :placeholder="$t('请选择')+$t('商品分类')"
                                   :replaceFields="{ children: 'children', title: 'categoryName', key: 'id', value: 'id' }"
                                   tree-default-expand-all allow-clear>
                    </a-tree-select>
                  </a-form-item>
                </a-col>
              <a-col :md="6" :sm="24">
                  <a-form-item :label="$t('商品状态')" prop="status">
                    <a-select :placeholder="$t('请选择')+$t('商品状态')" style="width: 100%" v-model="queryParam.status" allowClear>
                      <a-select-option v-for="(item, index) in customDict.GoodsStatusEnum" :value="item.type" :key="index">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="schoolId">
                  <span slot="label" ><a-tooltip>{{$t('学校')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-select show-search :filter-option="schoolFilter" :placeholder="$t('请选择')+$t('学校')" style="width: 100%" v-model="queryParam.schoolId" allowClear>
                    <a-select-option v-for="(item, index) in this.schoolList" :value="item.id+''" :key="index">
                      {{ item.schoolName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('学段')" prop="stage">
                  <a-select :placeholder="$t('请选择')+$t('学段')" style="width: 100%" v-model="queryParam.stage" allowClear>
                    <a-select-option v-for="(item, index) in schoolStageList" :value="item.id" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('季节')" prop="season">
                  <a-select :placeholder="$t('请选择')+$t('季节')" style="width: 100%" v-model="queryParam.season" allowClear>
                    <a-select-option v-for="(item, index) in customDict.GoodsUniformSeasonEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
          <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
            <img alt="example" style="width: 100%" :src="previewUrl" />
          </a-modal>
        </div>
        <a-tabs v-model="activeKey" @tabClick="changeTab">
          <a-tab-pane key="" tab="全部"/>
          <a-tab-pane v-for="pane in this.customDict.GoodsStatusEnum" :key="pane.type" :tab="pane.name">
          </a-tab-pane>
        </a-tabs>
      <!-- 操作 -->
        <div class="table-operations">
          <a-button type="primary" @click="handleAdd()" v-hasPermi="['goods:uniform:add']">
            <a-icon type="plus" />{{$t('新增')}}
          </a-button>
          <a-button type="primary" :disabled="single" @click="handleUpdate(ids)" v-hasPermi="['goods:uniform:edit']">
            <a-icon type="edit" />{{$t('修改')}}
          </a-button>
          <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['goods:uniform:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a-button>
          <a-button type="primary" :disabled="multiple" @click="handleBatchAudit" v-hasPermi="['goods:goods:audit']">
            <a-icon type="audit" />批量审核
          </a-button>
          <a-button type="primary" :disabled="multiple" @click="handleOn" v-hasPermi="['goods:goods:batchOn']">
            <a-icon type="check" />{{$t('批量上架')}}
          </a-button>
          <a-button type="danger" :disabled="multiple" @click="handleOff" v-hasPermi="['goods:goods:batchOff']">
            <a-icon type="stop" />{{$t('批量下架')}}
          </a-button>
          <a-button type="primary" @click="handleExport" v-hasPermi="['goods:goods:export']">
            <a-icon type="download" />{{$t('导出')}}
          </a-button>
          <a-button type="primary" :disabled="multiple" @click="handleSelectExport" v-hasPermi="['goods:goods:export']">
            <a-icon type="download" />{{$t('选中导出')}}
          </a-button>
          <table-setting
            :style="{float: 'right'}"
            :table-size.sync="tableSize"
            v-model="columns"
            :refresh-loading="loading"
            @refresh="getList" />
        </div>
        <!-- 数据展示 -->
        <a-table
          v-table-sticky="{ fixedTop: 64 }"
          :scroll="{ x: 1200 }"
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          @change="handleSortChange"
          :columns="columns"
          :data-source="list"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :pagination="false"
          :bordered="tableBordered"
        >
          <template slot="picture" slot-scope="text, record">
            <div>
              <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
            </div>
          </template>
          <span slot="stock" slot-scope="text, record">
            <a v-if="hasPermission('goods:mall:edit')" @click="updateSkuStock(record.id,record.goodsType)">{{record.stock}}</a>
            <span v-else>{{record.stock}}</span>
          </span>
          <span slot="brandId" slot-scope="text, record">
             {{getBrandNameById(record.brandId)}}
          </span>
<!--          <span slot="orderCount" slot-scope="text, record">
            <a v-if="hasPermission('goods:goods:rank')" @click="openRank(record)">{{record.orderCount}}</a>
            <span v-else>{{record.orderCount}}</span>
          </span>-->
          <div slot="status" slot-scope="text, record"  >
            <div v-if="hasPermission('goods:uniform:edit')">
              <a-select style="width: 80%" v-model="record.status"  @change="onStatusChange(record)" v-if="record.status===1|| record.status===0">
                <a-select-option v-for="(item, index) in customDict.GoodsOnOffEnum" :value="item.type" :key="index">
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <a-select style="width: 90%" v-model="record.status"  @change="onStatusChange(record)" v-else-if="record.status===3">
                <a-select-option v-for="(item, index) in customDict.GoodsAfterAuditStatusEnum" :value="item.type" :key="index">
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <span v-else class="status-with-tooltip">
                <custom-dict-tag :options="customDict.GoodsStatusEnum" :value="record.status"/>
                <a-tooltip v-if="record.failReason">
                  <a-icon type="question-circle" theme="twoTone" two-tone-color="#de1313" class="status-tooltip-icon" />
                  <template slot="title">
                    {{record.failReason}}
                  </template>
                </a-tooltip>
              </span>
            </div>
            <div v-else>
              <custom-dict-tag :options="customDict.GoodsStatusEnum" :value="record.status" />
            </div>
          </div>
          <span slot="stage" slot-scope="text, record">
            <custom-dict-tag :options="customDict.SchoolStageEnum" :value="record.stage"/>
          </span>
          <span slot="season" slot-scope="text, record">
            <custom-dict-tag :options="customDict.GoodsUniformSeasonEnum" :value="record.season"/>
          </span>
          <span slot="operation" slot-scope="text, record">
            <a-button size="small" type="link" @click="handleCopy(record, undefined)" >
               <a-icon type="copy" />{{$t('复制')}}
            </a-button>
            <a-button size="small" type="link" @click="$refs.goodsAuditForm.handleAudit([record.id])" v-if="record.status===2 || record.status===4" v-hasPermi="['goods:goods:audit']">
               <a-icon type="edit" />审核
            </a-button>
            <br>
            <a-button size="small" type="link" @click="handleUpdate(record, undefined)" v-hasPermi="['goods:uniform:edit']">
               <a-icon type="edit" />{{$t('修改')}}
            </a-button>
            <a-button size="small" type="link" @click="handleDelete(record)" v-hasPermi="['goods:uniform:remove']">
              <a-icon type="delete" />{{$t('删除')}}
            </a-button>
          </span>
        </a-table>
        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :pageSizeOptions="pageSizeOptions"
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="total => getTotal(total)"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </div>
    </a-card>
    <uniform-create-form ref="uniformCreateForm" :school-list="schoolList" :school-stage-list="schoolStageList" @ok="getList"/>
    <update-sku-stock ref="updateSkuStock" @ok="getList"></update-sku-stock>
    <goods-audit-form ref="goodsAuditForm" @ok="getList"/>
  </page-header-wrapper>
</template>

<script>
import {batchOn, batchOff, delGoods, pageUniformGoods, batchCopy} from '@/api/goods/goods'
import CustomDictTag from "@/components/DictCustomTag";
import {merchantBrand} from '@/api/goods/brand'
import UpdateSkuStock from "./modules/UpdateSkuStock";
import UniformCreateForm from "@/views/goods/goods/modules/UniformCreateForm.vue";
import {mapGetters} from 'vuex'
import {tableMixin} from '@/store/table-mixin'
import {platformCategoryList, merchantCategoryList} from "@/api/goods/category";
import bus from '@/utils/bus'
import moment from 'moment';
import store from "@/store";
import {listSelectMerchant} from "@/api/merchant/merchantMerchant";
import GoodsAuditForm from "@/views/goods/goods/modules/GoodsAuditForm.vue";
import {listSchool} from "@/api/school/school";
import {listSchoolGrade} from "@/api/school/schoolGrade";
import {listSchoolStage} from "@/api/school/schoolStage";



export default {
  name: 'Goods',
  components: {
    GoodsAuditForm,
    CustomDictTag,
    UpdateSkuStock,
    UniformCreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      merchantList:[],
      schoolList:[],
      schoolStageList:[],
      categoryList: [{id: "0", categoryName: ''}],
      cateOptions: [],
      pagetype: 1,  // 1商品列表 2新增编辑商品页面
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      brandList: [],
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      activeKey: '',
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        goodsCode: undefined,
        schoolId: undefined,
        isUnified: undefined,
        goodsName: undefined,
        goodsTypeList: [21],
        merchantCategoryId: undefined,
        merchantId: undefined,
        brandId: undefined,
        isRecommend: undefined,
        isNew: undefined,
        isRestriction: undefined,
        status: undefined,
        labelList: undefined,
        stage:undefined,
        season: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('商品编号'),
          dataIndex: 'id',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          fixed: 'left',
        },
        {
          title: this.$t('商品名称'),
          dataIndex: 'goodsName',
        },
        /*{
          title: this.$t('单位'),
          dataIndex: 'unit',
        },*/
        {
          title: this.$t('商品主图'),
          dataIndex: 'picture',
          width: '80px',
          scopedSlots: {customRender: 'picture'},
        },
        {
          title: this.$t('商品分类'),
          dataIndex: 'merchantCategoryName',
          width: '100px',
        },
        {
          title: this.$t('学段'),
          dataIndex: 'stage',
          scopedSlots: {customRender: 'stage'},
          width: '100px',
        },
        {
          title: this.$t('季节'),
          dataIndex: 'season',
          scopedSlots: {customRender: 'season'},
          width: '100px',
        },
        {
          title: this.$t('商品状态'),
          dataIndex: 'status',
          width: '100px',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: {customRender: 'status'},
        },
        /*      {
                title: this.$t('品牌'),
                dataIndex: 'brandId',
                scopedSlots: {customRender: 'brandId'},
              },*/
        {
          title: this.$t('库存'),
          dataIndex: 'stock',
          scopedSlots: {customRender: 'stock'},
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          width: '80px',
        },
        {
          title: this.$t('商品价'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'price',
          width: '80px',
        },
        {
          title: '所属商家',
          dataIndex: 'merchantName',
          width: '80px',
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          fixed: 'right',
          width: 200,
          scopedSlots: {customRender: 'operation'},
        }
      ]
    };
  },
  filters: {
  },
  created () {
    this.getList()
    this.getCategoryList();
    this.getBrandList();
    this.getMerchantList();
    this.getSchoolList();
    this.getSchoolStageList();
  },
  computed: {
    ...mapGetters(['customDict','userInfo'])
  },
  mounted() {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    //切换tab
    changeTab(index) {
      if (index == null) {
        index = undefined;
      }
      this.queryParam.status = index;
      this.getList();
    },
    hasPermission(val) {
      const allPermission = '*:*:*'
      const permissions = store.getters && store.getters.permissions
      const hasPermissions = permissions.some(permission => {
        return allPermission === permission || permissions.includes(permission)
      })
      return hasPermissions
    },

    getMerchantList () {
      listSelectMerchant({}).then(response => {
        this.merchantList = response.data
        /*if (this.userInfo.deptType !== 2) {
          //添加一条记录,放到首位
          this.merchantList.unshift({"id": 0,"merchantName":'平台'})
        }*/
      })
    },
    merchantFilter(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    getSchoolStageList () {
      this.loading = true
      listSchoolStage({}).then(response => {
        this.schoolStageList = response.data
      })
    },
    getSchoolList () {
      this.loading = true
      listSchool({}).then(response => {
        this.schoolList = response.data
      })
    },
    schoolFilter(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },

    getBrandList() {
      merchantBrand({}).then(response => {
        this.brandList = response.data
      })
    },
    /** 查询商品列表 */
    getList () {
      this.loading = true
      pageUniformGoods(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /*页面初始化时获取分类类别*/
    getCategoryList() {
      merchantCategoryList({}).then(response => {
        this.categoryList = response.data;
        let children = this.handleTree(response.data, 'id', 'pid')
        console.log('children', children)
        this.cateOptions = children
      })
    },


    getCategoryNameById(id) {
      if (!id) {
        return "";
      }
      let cateInfo = this.categoryList.find(e => e.id === id);
      if (cateInfo) {
        return cateInfo.categoryName
      } else {
        return "";
      }
    },
    getBrandNameById(id) {
      if (!id) {
        return "";
      }
      let brandInfo = this.brandList.find(e => e.id === id);
      if (brandInfo) {
        return brandInfo.name
      } else {
        return "";
      }
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        schoolId: undefined,
        isUnified: undefined,
        goodsCode: undefined,
        goodsName: undefined,
        goodsTypeList: [21],
        merchantCategoryId: undefined,
        merchantId: undefined,
        brandId: undefined,
        isRecommend: undefined,
        isNew: undefined,
        isRestriction: undefined,
        status: undefined,
        stage:undefined,
        season: undefined,
        labelList: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },




    onStatusChange(record) {
      //商品快捷上下架
      let data = {"idList": [record.id]};
      if (record.status===1) {
        batchOn(data).then(response => {
          if (response.code==='20001') {
            this.$message.success(this.$t('上架成功'), 3)
          }
          this.getList()
        })
      } else if (record.status===0) {
        batchOff(data).then(() => {
          this.getList()
          this.$message.success(
            this.$t('下架成功'),
            3
          )
        })
      }
    },

    updateSkuStock(goodsId,goodsType){
      this.$refs.updateSkuStock.show(goodsId,goodsType);
    },

    handlePreviewGoods(row) {
      let url = 'http://byg1688.com/goods/'+row.id
      window.open(url, '_blank')
    },
    handleCopy(row) {
      this.$refs.uniformCreateForm.handleUpdate(row.id, true)
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.$refs.uniformCreateForm.handleAdd()
    },
    /** 编辑商品信息 **/
    handleUpdate(row) {
      this.$refs.uniformCreateForm.handleUpdate(row.id)
    },

    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      const data = {"idList": this.ids}
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delGoods(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('删除成功'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 批量上架操作 */
    handleOn (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let data = {"idList": this.ids};
      this.$confirm({
        title: this.$t('确认上架'),
        onOk () {
          return batchOn(data)
            .then(response => {
              that.getList()
              if (response.code==='20001') {
                that.onSelectChange([], []);
                that.$message.success(
                  that.$t('上架成功'),
                  3
                )
              }
            })
        },
        onCancel () {
          //取消清空ids列表
          that.ids = []
        }
      })
    },

    handleBatchAudit () {
      const ids = this.ids
      this.$refs.goodsAuditForm.handleAudit(ids)
    },

    /** 批量下架操作 */
    handleOff(row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let data = {"idList": this.ids};
      this.$confirm({
        title: this.$t('确认下架'),
        onOk () {
          return batchOff(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('下架成功'),
                3
              )
            })
        },
        onCancel () {
          //取消清空ids列表
          that.ids = []
        }
      })
    },

    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/goods/goods/export',
            that.queryParam
          , `商品_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    handleSelectExport () {
      var that = this
      let queryParam = {"idList": this.ids}
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出选中数据'),
        onOk () {
          that.download('biz/admin/goods/goods/export', queryParam, `商品_${new Date().getTime()}.xlsx`)
          that.ids = []
          that.multiple=true
          that.selectedRowKeys=[]
        },
        onCancel () {
          that.ids = []
          that.multiple=true
          that.selectedRowKeys=[]
        }
      })
    }
  }
}
</script>
<style scoped>
.status-with-tooltip {
  display: inline-flex;
  align-items: center;
}

.status-tooltip-icon {
  margin-left: 6px;
}
</style>
